import { render, staticRenderFns } from "./MediaPanel.vue?vue&type=template&id=2bdb4bf6&scoped=true"
import script from "./MediaPanel.vue?vue&type=script&lang=js"
export * from "./MediaPanel.vue?vue&type=script&lang=js"
import style0 from "./MediaPanel.vue?vue&type=style&index=0&id=2bdb4bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb4bf6",
  null
  
)

export default component.exports